import React, { useState, useEffect } from 'react'
import firebase from 'firebase/app'
import 'firebase/database'
import { Marker } from 'types/markers'
import { flagMarker } from 'lib/model'
import fr from 'locales/fr.yaml'
const localisationStrings = { fr }

export const PopupContent = ({
  locale = 'fr',
  marker,
  userId,
  articleId,
  handleValidateRequest,
  handleEditRequest,
  handleDeleteRequest,
  handleSuggestChanges
}: {
  locale: 'fr'
  marker: Marker
  userId: string
  articleId: number
  handleValidateRequest: (markerId: string) => void
  handleEditRequest: (markerData: Marker) => void
  handleDeleteRequest: (markerId: string) => void
  handleSuggestChanges: (markerData: Marker) => void
}) => {
  const [votes, setVotes] = useState({ upvotes: 0, downvotes: 0 })
  const [initialVotes, setInitialVotes] = useState({ upvotes: 0, downvotes: 0 })
  const markerId = marker.markerId

  // TODO: delete this boolean when adminView is ready
  const showAdminTools = marker.needsReview ? marker.needsReview : false

  const sendVote = (
    markerId: string,
    userId: string,
    articleId: number,
    direction: string,
    initialVotes: { upvotes: number; downvotes: number }
  ) => {
    if (userId === null) {
      userId = window.localStorage.getItem(articleId + '-userId') || 'not-found'
      console.log('userId was undefined – found in localStorage:', userId)

      // TODO: make this an optional parameter and clean following lines
      if (userId === 'not-found') {
        console.warn('Vote impossible: l’utilisateur n’existe pas')
        return
      }
    }
    setVotes({
      upvotes: initialVotes.upvotes + (direction === 'up' ? 1 : 0),
      downvotes: initialVotes.downvotes + (direction === 'down' ? 1 : 0)
    })

    firebase
      .database()
      .ref('votes/' + markerId)
      .child(userId)
      .set({
        vote: direction === 'up' ? 1 : -1, // nb: utiliser increment / decrement?
        ts: firebase.database.ServerValue.TIMESTAMP // time since the Unix epoch, in milliseconds
      })
    console.log('Sent to firebase as child')
  }

  function getVotes(marker: string) {
    let upvotes = 0
    let downvotes = 0

    firebase
      .database()
      .ref('votes/' + marker)
      .once('value')
      .then(snapshot => {
        snapshot.forEach(item => {
          if (item.val().vote === 1) {
            upvotes += 1
          } else if (item.val().vote === -1) {
            downvotes += 1
          }
        })
        // this variable keeps track of user clicks
        setVotes({ upvotes: upvotes, downvotes: downvotes })
        // this one only remembers the database values
        setInitialVotes({ upvotes: upvotes, downvotes: downvotes })
      })
  }
  useEffect(() => {
    getVotes(markerId)
  }, [markerId])

  const handleFlag = (markerId: string) => {
    userId = window.localStorage.getItem(articleId + '-userId') || 'not-found'
    console.log('userId was undefined – found in localStorage:', userId)
    if (userId === 'not-found') {
      console.warn('Vote impossible: l’utilisateur n’existe pas')
      return
    }

    console.log('FLAG for', markerId)
    flagMarker(markerId, userId)
    alert('Merci d’avoir signalé cet emplacement.')
  }
  const Activities = () => {
    const activitiesStr = []
    if (marker.filter1 === true) {
      activitiesStr.push(localisationStrings[locale].filter1)
    }
    if (marker.filter2 === true) {
      activitiesStr.push(localisationStrings[locale].filter2)
    }
    if (marker.filter3 === true) {
      activitiesStr.push(localisationStrings[locale].filter3)
    }
    if (marker.filter4 === true) {
      activitiesStr.push(localisationStrings[locale].filter4)
    }
    if (activitiesStr.length < 1) {
      return null
    } else {
      let allActivities = activitiesStr[0]
      if (activitiesStr.length > 1) {
        const lastfilter = activitiesStr.pop()
        allActivities = activitiesStr.join(', ') + ' et ' + lastfilter
      }
      return (
        <p className='activities'>
          {localisationStrings[locale].placePurposes} <b>{allActivities}</b>.
        </p>
      )
    }
  }
  const Properties = () => {
    const propertyStr = []
    let allProperties = ''
    if (marker.car === true) {
      propertyStr.push('en voiture')
    }
    if (marker.bike === true) {
      propertyStr.push('à vélo')
    }
    if (marker.disabledAccess === true) {
      propertyStr.push('en chaise roulante')
    }
    if (marker.publicTransportation === true) {
      propertyStr.push('en transports publics')
    }
    if (propertyStr.length > 0) {
      allProperties = 'Accès facile ' + propertyStr.join(', ') + '. '
    }
    if (marker.familyFriendly === true) {
      allProperties += 'Adapté aux enfants'
    }
    if (allProperties !== '') {
      return <p className='properties'>{allProperties}</p>
    } else {
      return null
    }
  }
  const Votes = () => {
    if (showAdminTools) {
      return null
    } else {
      return (
        <div className='voters'>
          <button
            className='ui grey toggle button'
            onClick={() =>
              sendVote(marker.markerId, userId, articleId, 'up', initialVotes)
            }
          >
            {localisationStrings[locale].upvoteButton} ({votes.upvotes})
          </button>
          <button
            className='ui grey toggle button'
            onClick={() =>
              sendVote(marker.markerId, userId, articleId, 'down', initialVotes)
            }
          >
            {localisationStrings[locale].downvoteButton} ({votes.downvotes})
          </button>
        </div>
      )
    }
  }

  return (
    <>
      <h4 className='title'>{marker.title}</h4>
      <Activities />
      <Votes />
      <p className='description'>{marker.description}</p>
      <Properties />
      <p className='author'>
        {marker.nickname !== 'anonyme'
          ? 'Ajouté par ' + marker.nickname
          : 'Contribution anonyme'}
      </p>

      {showAdminTools ? (
        <div className='ui buttons small'>
          <button
            className='ui left attached button positive'
            onClick={() => handleValidateRequest(marker.markerId)}
          >
            Valider
          </button>
          <button
            className='ui attached button'
            onClick={() => handleEditRequest(marker)}
          >
            Editer
          </button>
          <button
            className='ui right attached button negative'
            onClick={() => handleDeleteRequest(marker.markerId)}
          >
            Supprimer
          </button>
        </div>
      ) : (
        <p>
          <button
            onClick={() => handleSuggestChanges(marker)}
            className='ui small blue basic compact labeled icon button'
          >
            <i className='lightbulb icon' />
            {localisationStrings[locale].updateButton}
          </button>
          <button
            onClick={() => handleFlag(marker.markerId)}
            className='ui small blue basic compact labeled icon button'
          >
            <i className='flag icon' />
            {localisationStrings[locale].flagButton}
          </button>
        </p>
      )}
    </>
  )
}
